var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.announcements && _vm.announcements.length)?_c('div',{staticClass:"announcement-boxes-container"},_vm._l((_vm.announcements),function(announcement){return _c('announcement-box',{key:announcement.id,attrs:{"announcement":announcement}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }